<template>
  <FamilyDrawerHeader
    sub-title="Befintlig kund anpassa extra mobilabonnemang"
  />
  <div
    class="px-16 md:px-24"
    :class="{ 'pt-24 md:pt-32': !familyStore.ui.isProductPage }"
  >
    <FamilyPdpGoBack class="pb-32" />
    <FamilyDiscountLabels :existing-customer="true" :in-drawer="true" />
    <div class="flex flex-col">
      <h3 class="heading-xs">Välj huvudabonnemang</h3>
      <p class="pb-16">
        Surfmängden för Halebop familj bestäms av huvudabonnemanget. Alla har
        sin egna surfmängd, man delar inte surfen.
      </p>
      <AppSelect
        v-if="familyStore.existingCustomer.plans?.length"
        id="plan-select-number"
        v-model="familyStore.selectedExistingCustomerPlanNumber"
        name="plan-select"
        label="Välj huvudabonnemang"
        classes="h-22"
        :options="selectOptions"
      />
    </div>
    <div aria-live="polite" class="flex flex-col">
      <AppErrorText
        v-if="familyStore.existingCustomerSelectedPlanAllowedConnections === 0"
        :id="EXISTING_CUSTOMER_ALLOWED_CONNECTIONS_ERROR_ID"
        tabindex="-1"
      >
        Du kan inte lägga till fler familjeanslutningar på det här abonnemanget
        än du redan har.
      </AppErrorText>
    </div>
    <FamilySectionBindPeriod v-if="!familyStore.ui.isProductPage" />
    <FamilySectionAddFamily />
  </div>
</template>

<script lang="ts" setup>
import { EXISTING_CUSTOMER_ALLOWED_CONNECTIONS_ERROR_ID } from '~/models/FamilyDrawerElementIds.model';

const familyStore = useFamilyStore();

const selectOptions = computed(() => {
  if (
    !familyStore.existingCustomer.plans ||
    familyStore.existingCustomer.plans.length === 0
  ) {
    return [];
  }

  return familyStore.existingCustomer.plans.map((plan) => ({
    label: `${plan.Number}, ${plan.DataAllowance} GB`,
    value: plan.Number,
  }));
});
</script>

<style scoped></style>
